import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmApiNeedTotpTfaError } from '@/core/error/transport/customErrors/tmApiNeedTotpTfaError'

export const authNeedTFATotpConfirmationRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.enter_totp_two_factor_code'],
  klass: TmApiNeedTotpTfaError,
}
